import { appliedQuoteFilterNames } from '../constants/quoteFilters'
import { TQuoteFilters } from '../types'

export const getAppliedFilterNames = (quoteFilters: TQuoteFilters): string => {
  const appliedFilters = []
  for (const key in quoteFilters) {
    if (Object.prototype.hasOwnProperty.call(quoteFilters, key)) {
      const filter = quoteFilters[key as keyof TQuoteFilters]
      if (
        (filter !== false || key !== 'isTestQuote') &&
        filter !== null &&
        filter?.toString() !== [].toString() &&
        filter !== undefined
      ) {
        appliedFilters.push(appliedQuoteFilterNames[key as keyof typeof appliedQuoteFilterNames])
      }
    }
  }
  return appliedFilters.join(', ')
}
